/** Message type for RN WebView — must match bedbooking_react_native `webViewOpenUrl`. */
export const BB_OPEN_URL = 'BB_OPEN_URL'

export type WebViewOpenUrlMethod = 'redirect' | 'newtab'
